import { BleDeviceCard } from './BleDeviceCard'
import { PolarLivePanel } from './SensorLivePanel'
import { usePolarDirect } from './usePolarDirect'

/**
 * `/admin/devices`: prueba en banco del Polar H10 por Web Bluetooth desde este
 * navegador. No graba bronze ni vincula nada: sirve para ver que el sensor
 * emite, con qué frecuencia cardíaca y a qué cadencia.
 *
 * Desde 2026-09-28 el setup de club es tablet + Polar + Quest (mg: "'base'
 * tampoco usamos"), así que esta ruta ya no monta el panel de placas y kits
 * (`DevicePanelContainer`, con la RPi, el GSR y las acciones remotas). Ese
 * panel y su lógica quedan en el código como camino edge opt-in (ADR 0002),
 * sin entrada desde la UI.
 */
export function PolarCheckPanel() {
  const polar = usePolarDirect()
  return (
    <section>
      <div className="rounded-md border border-primary/40 bg-surface-elevated p-lg shadow-[0_0_34px_rgba(226,90,27,0.10)]">
        <span className="tag">Sensores</span>
        <h1 className="mt-sm">Probar un Polar H10</h1>
        <p className="m-0 max-w-2xl text-sm leading-relaxed text-text-secondary">
          Web Bluetooth al H10 desde este navegador: sirve para verificar que el sensor emite, con
          qué frecuencia cardíaca y a qué cadencia. No graba bronze: eso lo hace la sesión en el
          visor.
        </p>
      </div>

      <div className="mt-lg rounded-md border border-surface-muted bg-surface-elevated p-md">
        {!polar.supported ? (
          <div className="banner-err">
            Web Bluetooth no está disponible en este navegador (usá Chrome o Edge).
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-md sm:grid-cols-2">
            <BleDeviceCard
              device={polar.snapshot}
              disabled={polar.connecting}
              onConnect={() => void polar.connect()}
              onDisconnect={() => polar.disconnect()}
            />
            <PolarLivePanel
              live={polar.live}
              connected={polar.connected}
              error={polar.error}
              onReset={() => polar.reset()}
            />
          </div>
        )}
      </div>
    </section>
  )
}
